const ServiceData = [
    {
        id: 1,
        serviceName: "Cancer Service",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quo, quidem?",
        image: require("../../Assets/Services/cancer.png")
    },
    {
        id: 2,
        serviceName: "Liver Transport",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quo, quidem?",
        image:  require("../../Assets/Services/liver.png")
    },
    {
        id: 3,
        serviceName: "Kedney Transport",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quo, quidem?",
        image:  require("../../Assets/Services/kedney.png")
    },
    {
        id: 4,
        serviceName: "Cardiac Arrhythmia",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quo, quidem?",
        image: require("../../Assets/Services/cardiac.png")
    },
    {
        id: 5,
        serviceName: "Neurology Care",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quo, quidem?",
        image:  require("../../Assets/Services/neurology.png")
    },
    {
        id: 6,
        serviceName: "Orthopedic Care",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quo, quidem?",
        image:  require("../../Assets/Services/Orthopedic.png")
    }
]

export default ServiceData;
